import { Route, RouteProps } from 'react-router-dom'
import FourOFour from 'app/FourOFour'
import { AuthContainer } from 'containers'
import { AccessLevelTypes } from 'types/userRoles'
import TermsAndConditions from 'pages/shared/TermsAndConditions'

type PrivateRouteProps = {
  children: React.ReactNode
  requiredAccessLevel?: AccessLevelTypes | AccessLevelTypes[]
  strictMultiAccessLevel?: boolean
}

export const PrivateRoute: React.FC<PrivateRouteProps & RouteProps> = ({ children, ...props }) => {
  const { requiredAccessLevel, strictMultiAccessLevel, ...rest } = props
  const { acceptedTnC, accessLevels } = AuthContainer.useContainer()

  const checkAccessLevel = () => {
    if (!requiredAccessLevel) return true

    switch (typeof requiredAccessLevel) {
      case 'string': {
        if (accessLevels?.includes(requiredAccessLevel)) return true
        break
      }
      case 'object': {
        if (
          (strictMultiAccessLevel && requiredAccessLevel?.every((item) => accessLevels?.includes(item))) ||
          (!strictMultiAccessLevel && !!accessLevels?.find((item) => requiredAccessLevel.includes(item)))
        ) {
          return true
        }
        break
      }
    }

    return false
  }

  return (
    <Route
      {...rest}
      render={({ location }) =>
        acceptedTnC && checkAccessLevel()
          ? children
          : (!acceptedTnC && <TermsAndConditions />) || (!checkAccessLevel() && <FourOFour errorCode="403" />)
      }
    />
  )
}
